import { Ref } from 'vue';
import { ComparePlansStore, ComparePlansStoreInterface } from '@/shared/infrastructure/store/ComparePlansStore';
import { usePlocState, getStore } from '@hfc/ui-core';

interface UseComparePlansStoreInterface {
  comparePlansStore: ComparePlansStore;
  comparePlansState: Ref<ComparePlansStoreInterface>;
}

export const useComparePlansStore = (): UseComparePlansStoreInterface => {
  const comparePlansStore = getStore<ComparePlansStore>('ComparePlansStore', ComparePlansStore);
  const comparePlansState = usePlocState(comparePlansStore) as Ref<ComparePlansStoreInterface>;

  return {
    comparePlansStore,
    comparePlansState,
  };
};
